import React, {useCallback, useContext, useRef} from 'react';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import {useDispatch, useSelector} from 'react-redux';
import {selectFilterStatus} from '../FilterSlice.jsx';
import FilterSideSheet from './large/FilterSideSheet.jsx';
import FilterGroupsSmall from './small/FilterGroups.jsx';
import FilterLayer from './small/FilterLayer.jsx';
import {
    mergeSelectedFiltersWithParams,
    yieldToMain
} from '../ArticleOverviewHelper.js';
import { setFilterAjaxCall} from '../AjaxCallSlice.jsx';
import {loadOffFilter, loadOnFilter} from '../LoaderSlice.jsx';
import {loadData} from '../helper/data-loader.js';
import JSONParser from '@core/scripts/helper/json-parser';
import useEffectOnUpdate from '../helper/hooks-helper.jsx';
import {useBreakpointUp} from "bonprix-design-system";

function Filter({filterContent, filterSubmit, ordering}) {
    const {filterAjaxUrl, shopId, currentSearchParams} = useContext(articleOverviewStaticContext);

    const breakpointLUp = useBreakpointUp('l');
    const filterOpened = useSelector(selectFilterStatus).opened;

    const dispatch = useDispatch();

    const clickedSortOption = useRef(undefined);
    const currentFilters = useRef(new Map());

    useEffectOnUpdate(() => {
        if (!filterOpened) {
            currentFilters.current = new Map();
            clickedSortOption.current = undefined;
        }
    }, [filterOpened]);


        const reloadOnlyFilters = async (clickedFilters, isRangeFilter) => {
        const mergedParams = mergeSelectedFiltersWithParams(clickedFilters, currentSearchParams.current);
        const shopIdFormatted = shopId.current ? `/${shopId.current}/` : '/';
        const filterAjaxCall = filterAjaxUrl + shopIdFormatted + '?' + mergedParams.toString();

        dispatch(setFilterAjaxCall([filterAjaxCall, isRangeFilter]));
    };

    const filterOptionChange = useCallback(
        async (identifier, trackingId, clickedFilters, isRange = false) => {
            dispatch(loadOnFilter());
            return await yieldToMain(async () => {
                const filterData = {
                    trackingId: trackingId,
                    clickedFilterOptions: clickedFilters,
                };

                currentFilters.current.set(identifier, filterData);

                if (isRange) {
                    const newHits = await reloadHits(currentFilters.current);
                    if (newHits) {
                        await reloadOnlyFilters(currentFilters.current, isRange);
                    } else {
                        currentFilters.current.delete(identifier);
                        dispatch(loadOffFilter());
                    }
                    return newHits;
                }

                await reloadOnlyFilters(currentFilters.current, isRange);
            });
        },
        [currentFilters.current, reloadOnlyFilters],
    );

    function reloadHits(clickedFilters) {
        const shopIdFormatted = shopId.current ? `/${shopId.current}/` : '/';

        const currentParamsCopy = mergeSelectedFiltersWithParams(clickedFilters, currentSearchParams.current);
        const filterAjaxRequest = filterAjaxUrl + shopIdFormatted + '?' + currentParamsCopy.toString();

        const newHitsContent = loadData(filterAjaxRequest);
        return newHitsContent.then((result) => {
            if (result) {
                const modelJson = JSONParser.tryParseJSON(result.model);
                return modelJson.hits;
            }
        });
    }

    const orderingChange = (sortValue, sortLm) => {
        clickedSortOption.current = {
            value: sortValue,
            lm: sortLm,
        };
    };

    const onSubmitButtonClick = () => {
        filterSubmit(currentFilters.current, clickedSortOption.current);
    };

    const classes = breakpointLUp ? '-side-sheet' : '';

    const filterAccordion = (
        <FilterGroupsSmall
            filterGroups={filterContent.filterGroups}
            shopIdFilterGroup={filterContent.shopIdFilterGroup}
            ordering={ordering}
            filterOptionChange={filterOptionChange}
            orderingChange={orderingChange}
            classes={classes}
        />
    );

    if (breakpointLUp) {
        return (
            <FilterSideSheet hits={filterContent.hits} filterSubmit={onSubmitButtonClick}>
                {filterAccordion}
            </FilterSideSheet>
        );
    }

    if (!breakpointLUp && filterOpened) {
        return (
            <FilterLayer hits={filterContent.hits} filterSubmit={onSubmitButtonClick}>
                {filterAccordion}
            </FilterLayer>
        );
    }

    return <></>;
}

export default Filter;
